import { useMutation, useQuery } from '@tanstack/react-query';
import { useDiscoveryClient } from '../api/context';
import type { GeoCatalog, TermSuggestResult } from '../api/types';

/** Countries and preset groups for the audience picker. Static per deploy. */
export function useGeoCatalog(enabled: boolean) {
  const client = useDiscoveryClient();
  return useQuery<GeoCatalog>({
    queryKey: ['discovery', 'geo', 'countries'],
    queryFn: () => client.geo.countries(),
    staleTime: Infinity,
    enabled,
  });
}

/**
 * Local search terms for a topic in the chosen countries, each measured with
 * one search page. A mutation rather than a query: it spends RapidAPI calls,
 * so it runs when someone asks, not whenever the inputs change.
 */
export function useSuggestTerms() {
  const client = useDiscoveryClient();
  return useMutation<TermSuggestResult, Error, { topics: string[]; countries: string[] }>({
    mutationFn: ({ topics, countries }) => client.geo.suggestTerms(topics, countries),
  });
}
